import { createTranslations } from './i18n/types';

export default createTranslations({
  en: {
    loading: 'Initializing application...',
    errorProfileLoad: 'Failed to load profile: {{error}}',
    errorUnexpected: 'An unexpected error occurred',
    errorSteamAlreadyLinked: 'This Steam account is already linked to another user',
    errorUserAlreadySteamLinked: 'Your account already has a linked Steam account',
    errorLinkFailed: 'Failed to link account: {{error}}',
  },
  ru: {
    loading: 'Инициализация приложения...',
    errorProfileLoad: 'Ошибка загрузки профиля: {{error}}',
    errorUnexpected: 'Произошла неожиданная ошибка',
    errorSteamAlreadyLinked: 'Этот аккаунт Steam уже привязан к другому пользователю',
    errorUserAlreadySteamLinked: 'К твоему аккаунту уже привязан Steam',
    errorLinkFailed: 'Ошибка привязки аккаунта: {{error}}',
  },
  uz: {
    loading: 'Ilova ishga tushirilmoqda...',
    errorProfileLoad: 'Profilni yuklashda xatolik: {{error}}',
    errorUnexpected: 'Kutilmagan xatolik yuz berdi',
    errorSteamAlreadyLinked: "Bu Steam akkaunt boshqa foydalanuvchiga bog'langan",
    errorUserAlreadySteamLinked: "Akkauntingizga allaqachon Steam bog'langan",
    errorLinkFailed: "Akkauntni bog'lashda xatolik: {{error}}",
  },
});
